module.exports = require('./convert')(
  "=\"#'()*+-/:;<>?@[\\]_z{|}",
  "¡¨·´)=(¿'-Ññ;:_\"`ç+?y^Ç*"
)
